import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {BDSharedModule} from '@brother-apps/brother-dealerapp-shared-lib';
import {BrowserModule} from '@angular/platform-browser';
import {CoreModule} from './core/core.module';
import {MasterDetailRootModule} from './modules/master-detail-root/master-detail-root.module';
import {NgModule} from '@angular/core';
import {NgSelectModule} from '@ng-select/ng-select';
import {SharedModule} from './shared/shared.module';
import localeDe from '@angular/common/locales/de';
import {registerLocaleData} from '@angular/common';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {tokenInterceptorFn} from './shared/interceptors/token.interceptor';
import {corsInterceptorFn} from './shared/interceptors/cors.interceptor';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {spinnerInterceptorFn} from './shared/interceptors/spinner-fn.interceptor';
import {httpErrorInterceptorFn} from './shared/interceptors/http-error-interceptor.interceptor';
import {DataProcessingAgreementModule} from './modules/data-processing-agreement/data-processing-agreement.module';

registerLocaleData(localeDe, 'de');

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        CoreModule,
        SharedModule,
        NgSelectModule,
        BDSharedModule,
        MasterDetailRootModule,
        BrowserAnimationsModule,
        DataProcessingAgreementModule
    ],
    providers: [
        provideHttpClient(
            withInterceptors([tokenInterceptorFn, corsInterceptorFn, spinnerInterceptorFn, httpErrorInterceptorFn]) // Register the functional interceptor
        ),
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
